import React from 'react';
import './App.css';
import { useRoutes, HashRouter, Navigate } from "react-router-dom";
import { Inicio } from '../Pages/Inicio';
import Contactos from '../Pages/Contactos'
import { ContactosV3 } from '../Pages/ContactosV3'
import { Tareas } from '../Pages/Tareas';
import { RolProvider, useRol } from '../Context';
import { Proyecto } from '../Pages/Proyecto';
import { Equipo } from '../Pages/Equipo';
import { Analisis } from '../Pages/Analisis';
import { Afinidad } from '../Pages/Afinidad';
import { Perfil } from '../Pages/Usuario/Perfil';
import { Contraseña } from '../Pages/Usuario/Contraseña';
import { Facturacion } from '../Pages/Usuario/Facturacion';
import { Soporte } from '../Pages/Usuario/Tickets';
import { PerfilContacto } from '../Pages/Contactos/PerfilContacto';
import { PerfilProyecto } from '../Pages/Proyecto/PerfilProyecto';
import { PerfilUsuario } from '../Pages/Equipo/PerfilUsuario';
import { SignIn } from '../Account/SignIn';
import { SignUp } from '../Account/SignUp';
import { SubirContactos } from '../Pages/Subir-contactos';
import { Tutoriales } from '../Pages/Tutoriales';
import ErrorBoundary from '../Components/UX/Error/ErrorBoundary';
import { Error } from '../Components/UX/Error';
import { DetallesTickets } from '../Pages/Usuario/Tickets/Detalles-tickets';
import { Loading } from '../Components/UX/Loading';

// Componente para rutas protegidas
const ProtectedRoute = ({ children }) => {
  const { user, loading, isInitialized, isLoadingAuth } = useRol();

  // Si no está inicializado o está cargando autenticación, mostrar un estado de carga
  if (!isInitialized || loading || isLoadingAuth) {
    return <Loading />;
  }

  // Si hay usuario en localStorage, permitir acceso
  if (user) {
    return children;
  }

  // Si no hay usuario, redirigir a sign-in
  return <Navigate to="/sign-in" replace />;
};

// Componente para rutas públicas (solo para usuarios no autenticados)
const PublicRoute = ({ children }) => {
  const { user, loading, isInitialized, isLoadingAuth } = useRol();

  // Si no está inicializado o está cargando autenticación, mostrar un estado de carga
  if (!isInitialized || loading || isLoadingAuth) {
    return <Loading />;
  }

  // Si hay usuario autenticado, redirigir a Inicio
  if (user) {
    return <Navigate to="/Inicio" replace />;
  }

  // Si no hay usuario, mostrar la página pública
  return children;
};

const AppRoutes = () => {
  let routes = useRoutes([
    {
      path: '/prospectia-movil-v3',
      element: <ProtectedRoute><Navigate to="/Inicio" /></ProtectedRoute>
    },
    {
      path: '/',
      element: <ProtectedRoute><Navigate to="/Inicio" /></ProtectedRoute>
    },
    {
      path: '/sign-in',
      element: <PublicRoute><SignIn /></PublicRoute>
    },
    {
      path: '/sign-up',
      element: <PublicRoute><SignUp /></PublicRoute>
    },
    {
      path: '/Inicio',
      element: <ProtectedRoute><Inicio /></ProtectedRoute>
    },
    {
      path: '/Contactos',
      element: <ProtectedRoute><ContactosV3 /></ProtectedRoute>
    },
    {
      path: '/ContactosV3',
      element: <ProtectedRoute><Contactos /></ProtectedRoute>
    },
    {
      path: '/Tutoriales',
      element: <ProtectedRoute><Tutoriales /></ProtectedRoute>
    },
    {
      path: '/Tareas',
      element: <ProtectedRoute><Tareas /></ProtectedRoute>
    },
    {
      path: '/Subir-contactos',
      element: <ProtectedRoute><SubirContactos /></ProtectedRoute>
    },
    {
      path: '/Proyectos',
      element: <ProtectedRoute><Proyecto /></ProtectedRoute>
    },
    {
      path: '/Equipo',
      element: <ProtectedRoute><Equipo /></ProtectedRoute>
    },
    {
      path: '/Analisis',
      element: <ProtectedRoute><Analisis /></ProtectedRoute>
    },
    {
      path: '/Afinidad',
      element: <ProtectedRoute><Afinidad /></ProtectedRoute>
    },
    {
      path: '/Perfil',
      element: <ProtectedRoute><Perfil /></ProtectedRoute>
    },
    {
      path: '/Contrasena',
      element: <ProtectedRoute><Contraseña /></ProtectedRoute>
    },
    {
      path: '/Facturacion',
      element: <ProtectedRoute><Facturacion /></ProtectedRoute>
    },
    {
      path: '/Soporte',
      element: <ProtectedRoute><Soporte /></ProtectedRoute>
    },
    {
      path: '/Perfil-de-contacto',
      element: <ProtectedRoute><PerfilContacto /></ProtectedRoute>
    },
    {
      path: '/Perfil-de-proyecto',
      element: <ProtectedRoute><PerfilProyecto /></ProtectedRoute>
    },
    {
      path: '/Perfil-de-usuario',
      element: <ProtectedRoute><PerfilUsuario /></ProtectedRoute>
    },
    {
      path: '/Detalles-soporte',
      element: <ProtectedRoute><DetallesTickets /></ProtectedRoute>
    },
    { path: '*', element: <Error /> },
  ])

  return routes
}

function App() {
  return (
    <HashRouter>
      <ErrorBoundary>
        <RolProvider>
          <AppRoutes />
        </RolProvider>
      </ErrorBoundary>
    </HashRouter>
  );
}

export default App;